import { useEffect, useRef, useState } from "react";

// Cadre à défilement horizontal : dégradé sur le bord droit tant qu'il reste du contenu à droite.
export const ScrollFade = ({ className = "", children, ...rest }) => {
  const ref = useRef(null);
  const [more, setMore] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const check = () => setMore(el.scrollLeft + el.clientWidth < el.scrollWidth - 2);
    check();
    el.addEventListener("scroll", check, { passive: true });
    const ro = new ResizeObserver(check);
    ro.observe(el);
    if (el.firstElementChild) ro.observe(el.firstElementChild);
    return () => { el.removeEventListener("scroll", check); ro.disconnect(); };
  }, []);
  return (
    <div className="relative">
      <div ref={ref} className={`overflow-x-auto ${className}`} {...rest}>{children}</div>
      <div aria-hidden="true" data-testid="scroll-fade"
        className={`pointer-events-none absolute inset-y-0 right-0 w-10 bg-gradient-to-l from-white to-transparent transition-opacity duration-200 ${more ? "opacity-100" : "opacity-0"}`} />
    </div>
  );
};

export default ScrollFade;
